import { useGetUserQuery } from 'common'

const LOCAL_STORAGE_FEATURES_KEY = 'Team Features'
const COLLECT_PAYMENT_FEATURE_KEY = 'collect_payment'
export const ONBOARDING_PAYMENTS_EXPERIMENT_KEY = 'growth_configure_payments_after_onboarding'
const ONBOARDING_PAYMENTS_VARIANTS = {
  CONTROL: 'control',
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
  VARIANT_3: 'variant_3',
}

export const hasOnboardingPaymentsFlag = () => {
  const { localStorage } = window || {}
  if (!localStorage) return false

  const storedFeatures = localStorage.getItem(LOCAL_STORAGE_FEATURES_KEY)
  if (!storedFeatures) return false

  try {
    const features = JSON.parse(storedFeatures)
    return Array.isArray(features) && features.includes(COLLECT_PAYMENT_FEATURE_KEY)
  } catch (error) {
    return false
  }
}

export const isOnboardingPaymentsBannerVariant = (variant) => (
  [
    ONBOARDING_PAYMENTS_VARIANTS.VARIANT_2,
    ONBOARDING_PAYMENTS_VARIANTS.VARIANT_3
  ].includes(variant)
)

export const useOnboardingPaymentsFullSizeModalVisible = (variant) => {
  const { data: user } = useGetUserQuery()

  // Don't show until user data is loaded to prevent mutation failures
  if (!user) return false

  const isModalDismissed = Boolean(
    user.growth_experiments?.[ONBOARDING_PAYMENTS_EXPERIMENT_KEY]?.full_page_modal_dismissed
  )

  return !isModalDismissed && [
    ONBOARDING_PAYMENTS_VARIANTS.VARIANT_1,
    ONBOARDING_PAYMENTS_VARIANTS.VARIANT_3
  ].includes(variant)
}
